export default {
  items: [
    {
      title: true,
      name: 'VERWALTUNG',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Dashboard',
      url: '/pc/dashboard',
      icon: 'icon-home'
    },
    {
      name: 'Monitore',
      url: '/monitors',
      icon: 'cil-monitor',
      children: [
        {
          name: 'Übersicht',
          url: '/pc/monitors/overview'
        },
        {
          name: 'Gruppen',
          url: '/pc/monitors/groups'
        },
        {
          name: 'Gruppen-Zuweisung',
          url: '/pc/monitors/groupassignment'
        }
      ]
    },
    {
      name: 'Werbung',
      url: '/advertisements',
      icon: 'fa fa-building',
      children: [
        {
          name: 'Neu',
          url: '/pc/advertisements/new'
        },
        {
          name: 'Freigabeliste',
          url: '/pc/advertisements/approvallist'
        },
        {
          name: 'Planer',
          url: '/pc/advertisements/planner'
        },
        // {
        //   name: 'Auswertung',
        //   url: '/pc/advertisements/evaluation'
        // }
      ]
    },
    // {
    //   name: 'Administration',
    //   url: '/administration',
    //   children: [
    //     {
    //       name: 'Einstellungen',
    //       url: '/pc/administration/settings'
    //     }
    //   ]
    // },
    {
      title: true,
      name: 'UNTERSTÜTZUNG',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Support',
      url: '/pc/support',
      icon: 'icon-speedometer',
    }
  ]
}
